"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withOperator = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _helpers = require("@otpusk/apisearch-toolbox/dist/geo/helpers");
var _selectors = require("@otpusk/apisearch-toolbox/dist/geo/selectors");
var _selectors2 = require("@otpusk/apisearch-toolbox/dist/search/selectors");
var _selectors3 = require("@otpusk/apisearch-toolbox/dist/queries/selectors");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var R = _interopRequireWildcard(require("ramda"));
var _external = require("../../../../../bus/external");
var _config = require("../../../../../services/config");
var _ConfirmModal = require("../../../../ConfirmModal");
var _Button = _interopRequireWildcard(require("../../../../ui/Button"));
var _excluded = ["countryID", "operatorID", "queryID"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var PEGAS_ID = '269';
var onRedirectToOperatorSiteBySearch = function onRedirectToOperatorSiteBySearch(operator) {
  return R.call(R.when(Boolean, function (callback) {
    return callback(operator);
  }), (0, _config.getOnRedirectToOperatorSiteBySearch)());
};
var withOperator = exports.withOperator = function withOperator(Component) {
  var WithOperator = function WithOperator(_ref) {
    var countryID = _ref.countryID,
      operatorID = _ref.operatorID,
      queryID = _ref.queryID,
      props = _objectWithoutProperties(_ref, _excluded);
    var dispatch = (0, _reactRedux.useDispatch)();
    var _useTranslation = (0, _reactI18next.useTranslation)('RESULTS'),
      t = _useTranslation.t;
    var departureID = (0, _reactRedux.useSelector)(function (state) {
      return (0, _selectors3.getQueryParam)(state, {
        paramName: _fn.QUERY_PARAMS.DEPARTURES,
        queryID: queryID
      }).first();
    });
    var memoizeGetOperators = (0, _react.useMemo)(function () {
      return R.partialRight((0, _selectors.getOperator)(), [{
        key: (0, _helpers.generateOperatorKey)(countryID, departureID),
        operatorID: operatorID
      }]);
    }, [countryID, departureID, operatorID]);
    var operator = (0, _reactRedux.useSelector)(memoizeGetOperators);
    var url = (0, _reactRedux.useSelector)(function (state) {
      return (0, _selectors2.getOperatorLink)(state, {
        queryID: queryID,
        operatorID: operatorID
      });
    });
    var _useSelector = (0, _reactRedux.useSelector)(function (state) {
        return (0, _external.getBookingTypes)(state, {
          operatorID: operatorID
        });
      }),
      isBookingByOperator = _useSelector.isBookingByOperator;
    var handleRedirectToOperatorSite = (0, _react.useCallback)(function () {
      return operator.id !== PEGAS_ID && onRedirectToOperatorSiteBySearch(operator);
    }, [operator]);
    var handleClickByOperatorLogo = (0, _react.useCallback)(function (event) {
      return operator.id === PEGAS_ID && (event.preventDefault(), dispatch((0, _ConfirmModal.showConfirmModal)(function (isConfirmed) {
        return isConfirmed && (onRedirectToOperatorSiteBySearch(operator), global.window.open(url, '_blank'));
      }, {
        header: t('PRICE_ANALYTICS_CONFIRM_MODAL_AFTER_REDIRECT_TO_OPERATORS_SITES_TITLE'),
        content: t('PRICE_ANALYTICS_CONFIRM_MODAL_AFTER_REDIRECT_TO_OPERATORS_SITES_TEXT'),
        cancelButton: false,
        confirmButton: /*#__PURE__*/_react.default.createElement(_Button.default, {
          theme: _Button.THEMES.PURPLE
        }, t('PRICE_ANALYTICS_CONFIRM_MODAL_AFTER_REDIRECT_TO_OPERATORS_SITES_CONFIRM_BUTTON'))
      })));
    }, [dispatch, operator, t, url]);
    var propsOfArrowLink = (0, _react.useMemo)(function () {
      var isEnabledAds = R.and(isBookingByOperator, !(0, _config.isDisabledAdvertiseByOperator)(operatorID));
      if (isEnabledAds && url) {
        return {
          href: url,
          onClick: handleClickByOperatorLogo,
          onMouseUp: handleRedirectToOperatorSite
        };
      }
      return undefined;
    }, [isBookingByOperator, handleClickByOperatorLogo, handleRedirectToOperatorSite, operatorID, url]);
    return Boolean(operator) && /*#__PURE__*/_react.default.createElement(Component, _extends({}, props, {
      arrowLink: propsOfArrowLink,
      logo: operator.logo,
      name: operator.name
    }));
  };
  WithOperator.propTypes = {
    countryID: _propTypes.default.string.isRequired,
    operatorID: _propTypes.default.number.isRequired,
    queryID: _propTypes.default.string.isRequired
  };
  return WithOperator;
};